import ReactECharts from "echarts-for-react";

export type GaugeChartProps = {
  options?: any;
  style?: { height?: string; width?: string };
};

const GaugeChart = ({ style, options }: GaugeChartProps) => {
  // Default options
  const defaultOptions = {
    series: {
      type: "gauge",
    },
  };

  // Merge the default options with the provided options (if any)
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    series: {
      ...defaultOptions.series, // Use default options for each series
      ...options?.series,
    },
  };

  return <ReactECharts style={style} option={mergedOptions} opts={{ renderer: "svg" }} />;
};

export default GaugeChart;
